import {useState} from 'react'
import HarvestDetailsForm from './HarvestDetailsForm';
import HarvestDetailsList from './HarvestDetailsList';

const HarvestDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <HarvestDetailsForm addForm={setFromIsShown} update={upData} />
        ) : (
          <HarvestDetailsList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default HarvestDetails